/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadFileResponse } from './UploadFileResponse';
import {
    UploadFileResponseFromJSON,
    UploadFileResponseFromJSONTyped,
    UploadFileResponseToJSON,
    UploadFileResponseToJSONTyped,
} from './UploadFileResponse';

/**
 * 
 * @export
 * @interface ResultOfUploadFileResponse
 */
export interface ResultOfUploadFileResponse {
    /**
     * 
     * @type {UploadFileResponse}
     * @memberof ResultOfUploadFileResponse
     */
    data: UploadFileResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfUploadFileResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfUploadFileResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfUploadFileResponse interface.
 */
export function instanceOfResultOfUploadFileResponse(value: object): value is ResultOfUploadFileResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfUploadFileResponseFromJSON(json: any): ResultOfUploadFileResponse {
    return ResultOfUploadFileResponseFromJSONTyped(json, false);
}

export function ResultOfUploadFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfUploadFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UploadFileResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfUploadFileResponseToJSON(json: any): ResultOfUploadFileResponse {
    return ResultOfUploadFileResponseToJSONTyped(json, false);
}

export function ResultOfUploadFileResponseToJSONTyped(value?: ResultOfUploadFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UploadFileResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

